import { Injectable } from '@angular/core';
import posthog from 'posthog-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PosthogService {
  constructor() {
    // Posthog service has been disabled
    /*
    posthog.init(environment.posthog.apiKey, {
      api_host: environment.posthog.apiHost,
      capture_pageview: true,
      autocapture: true,
      disable_session_recording: false,
      session_recording: {
        maskAllInputs: false,
      },
    });
    */
  }

  identifyUser(id: string, email?: string) {
    // posthog.identify(email, { email });
  }

  capture(eventName: string, properties?: any) {
    // posthog.capture(eventName, properties);
  }

  reset() {
    // posthog.reset();
  }
}

